import { HTMLAttributes, ReactNode } from 'react'
import './Badge.css'

export type BadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'danger'
export type BadgeSize = 'small' | 'medium'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** Badge visual style */
  variant?: BadgeVariant
  /** Badge size */
  size?: BadgeSize
  /** Children content */
  children: ReactNode
}

/**
 * Badge component for status indicators and labels
 * Used for license status, tags, etc.
 */
export default function Badge({
  variant = 'default',
  size = 'medium',
  children,
  className = '',
  ...props
}: BadgeProps) {
  const badgeClasses = [
    'ps-badge',
    `ps-badge--${variant}`,
    `ps-badge--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={badgeClasses} {...props}>
      {children}
    </span>
  )
}
